<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.user_id"
        placeholder="请输入用户ID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.title"
        placeholder="请输入标题"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.content"
        placeholder="请输入内容"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.type"
        placeholder="类型"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="图文" :value="1" />
        <el-option label="视频" :value="2" />
      </el-select>
      <el-select
        v-model="listQuery.is_on"
        placeholder="状态"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="正常" :value="1" />
        <el-option label="已下架" :value="0" />
      </el-select>

      <el-button class="filter-item" type="primary" @click="handleFilter">
        搜索
      </el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="序号" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>
      <el-table-column label="用户ID" width="95" align="center">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="头像" min-width="110" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.user"
            :src="scope.row.user.avatar"
            class="user-avatar"
          />
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user?scope.row.user.nickname:"-" }}
        </template>
      </el-table-column>
      <el-table-column label="标题" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>
      <el-table-column label="类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type == 1" type="success">图文</el-tag>
          <el-tag v-else type="danger">视频</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="图文、视频" min-width="110" align="center">
        <template slot-scope="scope">
          <!-- {{ scope.row.reference_price }} -->
        </template>
      </el-table-column>
      <el-table-column label="文字内容" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.content }}
        </template>
      </el-table-column>
      <el-table-column label="评论人数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.comment_num }}
        </template>
      </el-table-column>
      <el-table-column label="点赞人数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.like_num }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_on == 1" type="success">正常</el-tag>
          <el-tag v-else type="danger">已下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="是否置顶" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.top_weight == 0" type="danger">否</el-tag>
          <el-tag v-else type="success">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="权重" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.top_weight }}
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        width="280"
        align="center"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleCreate(scope.row, 1)"
          >
            查看详情
          </el-button>
          <el-button
            v-if="scope.row.is_on == 1"
            size="mini"
            type="danger"
            @click="handleStatus(scope.row.id, '下架')"
            >下架</el-button
          >
          <el-button
            v-else
            size="mini"
            type="success"
            @click="handleStatus(scope.row.id, '上架')"
            >上架</el-button
          >
          <el-button
            size="mini"
            type="warning"
            @click="handleCreate(scope.row, 2)"
          >
            用户评论
          </el-button>
          <el-button
            size="mini"
            type="primary"
            v-if="scope.row.top_weight==0"
            @click="weight(scope.row.id,1)"
          >
            置顶
          </el-button>
          <el-button
            size="mini"
            type="danger"
            v-else-if="scope.row.top_weight>0"
            @click="weight(scope.row.id,0)"
          >
            取消置顶
          </el-button>
          <el-button
            v-if="scope.row.top_weight>0"
            size="mini"
            type="warning"
            @click="weight(scope.row.id,scope.row.top_weight)"
          >
            权重设置
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: "",
        title: "",
        content: "",
        type: "",
        is_on: "",
      },
      btnLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    weight(id,Topping){
       console.log(Topping); 
       if(Topping==0){
          request({
            url: "/api/backend/post/topWeightStore",
            method: "post",
            data: { post_id:id,top_weight: 0 },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
          return;
       }
       this.$prompt( '请输入置顶权重','提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: '格式不正确',
          inputType:'Number',
          inputValue:Topping
          
        }).then(({ value }) => {
          
          request({
            url: "/api/backend/post/topWeightStore",
            method: "post",
            data: { post_id:id,top_weight: value },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
    },  
    handleGoList(row) {
      this.$router.push(`/music/pay_list?id=${row.id}`);
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/post/list",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCreate(row, type) {
      if (type == 1) {
        this.$router.push(`/forum/forum_details?id=${row.id}`);
      } else {
        this.$router.push(`/forum/forum_user?id=${row.id}`);
      }
    },
    //上下架
    handleStatus(val, text) {
      this.$confirm("此操作将" + text + "该帖子, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/post/upDown",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    //删除
    handleShow(val, text) {
      this.$confirm("此操作将帖子" + text + ", 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/course/categoryIndexShow",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
